function ScanViewfinder() {
    return (
        <div
            className="scanner-viewfinder"
            style={{
                position: "absolute",
                borderWidth: "245px 45px",
                borderStyle: "solid",
                borderColor: "rgba(0, 0, 0, 0.48)",
                boxSizing: "border-box",
                inset: "0px",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "40px",
                    height: "5px",
                    top: "-5px",
                    left: "-1px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "40px",
                    height: "5px",
                    top: "-5px",
                    right: "-1px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "40px",
                    height: "5px",
                    bottom: "-5px",
                    left: "-1px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "40px",
                    height: "5px",
                    bottom: "-5px",
                    right: "-1px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "4px",
                    height: "45px",
                    top: "-5px",
                    left: "-4px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "4px",
                    height: "45px",
                    top: "-5px",
                    left: "-5px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "4px",
                    height: "45px",
                    bottom: "-5px",
                    left: "-4px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "4px",
                    height: "45px",
                    top: "-5px",
                    right: "-4px",
                }}
            ></div>
            <div
                style={{
                    position: "absolute",
                    backgroundColor: "rgb(255, 255, 255)",
                    width: "4px",
                    height: "45px",
                    bottom: "-5px",
                    right: "-4px",
                }}
            ></div>
        </div>
    );
}

export default ScanViewfinder;
